module.exports = __webpack_public_path__ + "static/media/icon-tasks.381b183c.svg";